import { useMutation, UseMutationOptions } from 'react-query'

import { reloadMetadataAfterObjectChange } from 'data/hooks/refreshData'
import { fetchAndReturn } from 'data/utils/utils'

export function useDeleteDataConnection(options: UseMutationOptions<any, any, any> = {}) {
    return useMutation(
        async (dataConnectionSid: string) => {
            return fetchAndReturn(`data-connections/${dataConnectionSid}/`, {
                method: 'DELETE',
                headers: {
                    'Content-type': 'application/json',
                },
            })
        },
        {
            ...options,
            onSettled: () => {
                reloadMetadataAfterObjectChange()
            },
        }
    )
}
